<template>
  <div>
    <div
      class="flex items-center rounded-md"
      :class="active ? 'bg-primary-100' : 'hover:bg-gray-100'"
      :style="{ paddingLeft: `${depth * 14}px` }"
    >
      <button v-if="hasChildren" type="button" class="w-7 py-2 text-gray-500 text-[10px] shrink-0" @click="$emit('toggle', node.key)">
        <font-awesome-icon :icon="['fas', open ? 'chevron-down' : 'chevron-right']" />
      </button>
      <span v-else class="w-7 shrink-0"></span>
      <router-link v-if="node.to" :to="node.to" class="flex flex-1 items-center gap-2 min-w-0 py-1.5 pr-2 no-underline text-gray-800">
        <font-awesome-icon v-if="node.icon" :icon="node.icon" class="text-gray-400 text-xs shrink-0" />
        <span class="truncate text-[13px]" :class="['font-medium', { sensitive: node.sensitive }]">{{ node.label }}</span>
      </router-link>
    </div>
    <template v-if="hasChildren && open">
      <PagesTreeNode
        v-for="child in node.children" :key="child.key"
        :node="child" :depth="depth + 1" :expanded="expanded" :active-path="activePath"
        @toggle="$emit('toggle', $event)"
      />
    </template>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'PagesTreeNode',
  components: { FontAwesomeIcon },
  props: {
    node: { type: Object, required: true },
    depth: { type: Number, default: 0 },
    expanded: { type: Object, required: true },
    activePath: { type: String, default: '' },
  },
  emits: ['toggle'],
  computed: {
    hasChildren() {
      return !!(this.node.children && this.node.children.length);
    },
    open() {
      return !!this.expanded[this.node.key];
    },
    active() {
      return !!this.node.to && this.$router.resolve(this.node.to).path === this.activePath;
    },
  },
};
</script>
